import React, { useId } from 'react'
import { Button } from 'react-bootstrap'
import print from 'print-js'

import { useWorkflow } from '../providers/workflow_provider'
import { useInstallation } from '../providers/installation_provider'

interface PrintSectionProps {
    children: React.ReactNode
    label: React.ReactNode
}

const PrintSection: React.FC<PrintSectionProps> = ({ children, label }) => {
    const printContainerId = useId()
    const isSafari = () =>
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    const addSafariHeader = () => {
        if (isSafari()) {
            const printWrapper = document.getElementById(printContainerId)
            if (printWrapper) {
                const header = document.createElement('div')
                header.className = 'safari-print-header'
                header.innerText = process.env.REACT_APP_PRINT_TITLE
                printWrapper.prepend(header) // Add header at the top
            }
        }
    }

    const [installation] = useInstallation()

    const report_title = useWorkflow()?.title
    const report_subtitle = useWorkflow()?.subtitle

    const modifiedChildren = React.Children.map(children, child => {
        if (
            React.isValidElement(child) &&
            child.type === 'h1' &&
            child.props.id === 'report_title'
        ) {
            // Replace the <h1 id="title"> element
            return <h1 id="report_title">{report_title}</h1>
        } else if (
            React.isValidElement(child) &&
            child.type === 'h2' &&
            typeof (child.props as { id?: string }).id === 'string' &&
            (child.props as { id?: string }).id === 'report_subtitle'
        ) {
            // Replace the <h2 id="subtitle"> element
            return (
                <h2 id="report_subtitle">
                    {report_subtitle} Report for{' '}
                    <strong>{installation?.metadata_.doc_name}</strong>
                </h2>
            )
        }
        return child
    })

    return (
        <>
            <Button
                onClick={() => {
                    addSafariHeader()
                    print({
                        maxWidth: 2000,
                        printable: printContainerId,
                        onPrintDialogClose: () => {
                            document.title = process.env.REACT_APP_NAME
                        },
                        type: 'html',
                        targetStyles: ['*'],
                        css: ['/bootstrap.min.css', '/print.css'],
                        documentTitle: process.env.REACT_APP_PRINT_TITLE,
                        scanStyles: false,
                    })
                }}
                variant="primary"
            >
                {label}
            </Button>
            <div id={printContainerId}>
                <div className="print-wrapper">{modifiedChildren}</div>
            </div>
        </>
    )
}

export default PrintSection
